import { parsePhoneNumber } from 'libphonenumber-js';
import { DEFAULT_LANGUAGE } from 'constants/language';
import isValidPhoneNumber from './isValidPhoneNumber';
export const getPhoneNumberValue = phoneNr => isValidPhoneNumber(phoneNr ?? '') ? parsePhoneNumber(phoneNr ?? '', DEFAULT_LANGUAGE).number : '';
export const getPhoneNumberString = phoneNr => isValidPhoneNumber(phoneNr ?? '') ? parsePhoneNumber(phoneNr ?? '', DEFAULT_LANGUAGE).formatInternational() : phoneNr;